import i18n from 'live/services/i18n'
import moment from 'moment'

import { ApprovalSettingsType } from '../types/ApprovalSettings'

export function formatAssetNameByRegex(assetName: string, regex: RegExp): string {
    return assetName.replace(regex, '')
}

export function validateFields(
    approvalSettings: ApprovalSettingsType
): {
    pass: boolean
    message: string
} {
    let pass = true
    let message = ''

    if (!approvalSettings.reportId) {
        pass = false
        message = 'Report ID is missing in the approval settings.'
    }

    if (!approvalSettings.reportName) {
        pass = false
        message = 'Report Name is missing in the approval settings.'
    }

    if (!approvalSettings.alertRuleId) {
        pass = false
        message = 'Alert Rule ID is missing in the approval settings.'
    }

    if (!approvalSettings.alertRuleName) {
        pass = false
        message = 'Alert Rule Name is missing in the approval settings.'
    }

    if (!approvalSettings.assets.length) {
        pass = false
        message = 'Assets list is missing in the approval settings.'
    }

    if (!approvalSettings.frequency) {
        pass = false
        message = 'Frequency is missing in the approval settings.'
    }

    if (!approvalSettings.hour) {
        pass = false
        message = 'Hour is missing in the approval settings.'
    }

    if (!approvalSettings.scheduleName) {
        pass = false
        message = 'Schedule Name is missing in the approval settings.'
    }

    if (!approvalSettings.recipientGroupId) {
        pass = false
        message = 'Recipient Group ID is missing in the approval settings.'
    }

    if (!approvalSettings.timespan) {
        pass = false
        message = 'Timespan is missing in the approval settings.'
    }

    if (!approvalSettings.uid) {
        pass = false
        message = 'UID is missing in the approval settings.'
    }

    return { pass, message }
}

export function mountFullDateAccordingToLocale(timespan: string, isDateToUrl?: boolean): string {
    const isPT_BR = moment.locale() === 'pt-br'

    const splitDate = timespan.split(' to ')
    const startDate = moment(splitDate[0]).format(
        `${isDateToUrl ? 'YYYY-MM-DD HH:mm' : isPT_BR ? 'DD/MM/YYYY LT' : 'YYYY/MM/DD LT'}`
    )
    const endDate = moment(splitDate[1]).format(
        `${isDateToUrl ? 'YYYY-MM-DD HH:mm' : isPT_BR ? 'DD/MM/YYYY LT' : 'YYYY/MM/DD LT'}`
    )

    const mountedDate = `${startDate} ${isDateToUrl ? 'to' : i18n('to')} ${endDate}`

    return mountedDate
}
